export const global = {
  intervention: "Intervention",
  interventionPlural: "Interventions",
  interventionTemplate: "Gabarits d'intervention",
  interventionTemplatePlural: "Gabarits d'intervention",
  cost: "Coût",
  activityPlural: "Activités",
  add: "Ajouter",
  addGroup: "Ajouter un groupe",
  advancement: "% d'avancement",
  and: "et",
  alert: "Alerte",
  apiVersion: "Version d'API",
  appVersion: "Version de l'interface",
  apply: "Appliquer",
  asset: "Actif",
  assetPlural: "Actifs",
  assetType: "Type d'actif",
  assetTypePlural: "Types d'actifs",
  technicalForm: "Formulaire technique",
  technicalFormPlural: "Formulaires techniques",
  associateEmpty: "Associer",
  associate: "Associer une intervention",
  associate_other: "Associer {{count}} interventions",
  asyncDeleteNotification:
    "La ressource et ses données liées seront supprimées de manière asynchrone. Vous recevrez une notification lorsque la suppression sera terminée.",
  asyncBatchDeleteNotification:
    "Les ressources et leurs données liées seront supprimées de manière asynchrone. Vous recevrez une notification lorsque la suppression sera terminée.",
  pendingDeletion: "Suppression en cours",
  batchEdit: {
    label: "Modifier en lot",
  },
  batchEditSelect: {
    description: "Veuillez sélectionner la propriété à mettre à jour.",
    label: "Propriété à mettre à jour",
    placeholder: "Sélectionner une propriété",
  },
  batchDelete: {
    label: "Supprimer en lot",
    message: {
      label:
        "Vous allez supprimer {{count}} ressource{{plural}}. Regardez les options ci-dessous.",
    },
  },
  batchRestore: {
    label: "Restaurer en lot",
  },
  batchTransition: {
    title: "État",
    noNextStates: "Aucune modification possible",
    stateDisabledTooltip:
      "La modification en lot est applicable uniquement pour les états : {{states}}.",
  },
  batchPreview: {
    defaultTitle: "Aperçu de modification en lot",
    mismatchState:
      "L'état peut différer si celui-ci a été mis à jour entretemps.",
    assign: {
      intervention: {
        link: "Voir les interventions",
        title: "Nouvelles interventions assignées",
        description: "{{userName}} vous a assigné {{count}} interventions.",
      },
      project: {
        link: "Voir les projets",
        title: "Nouveaux projets assignés",
        description: "{{userName}} vous a assigné {{count}} projets.",
      },
    },
    transition: {
      observation: {
        link: "Voir les observations",
        title: "Changement d'état des observations",
        description:
          "{{userName}} a changé l'état des observations suivantes à <StateTag />",
      },
      intervention: {
        link: "Voir les interventions",
        title: "Changement d'état des interventions",
        description:
          "{{userName}} a changé l'état des interventions suivantes à <StateTag />",
      },
    },
  },
  empty: {
    intervention: "Aucune intervention",
    observation: "Aucune observation",
    project: "Aucun projet",
  },
  table: {
    filter: "Filtrer",
    reset: "Réinitialiser",
    ok: "OK",
  },
  batch: "Lot",
  ok: "OK",
  copy: "Copie",
  copyButton: {
    label: "Copier les données",
    success: "Données copiées dans le presse-papiers !",
    error: "Échec de la copie des données",
  },
  cancel: "Annuler",
  category: "Catégorie",
  close: "Fermer",
  conditionRating: "Cote d'état",
  confirm: "Confirmer",
  coordinate: {
    label: "Coordonnées GPS",
    placeholder: "Coordonnées",
  },
  create: "Créer",
  date: "Date",
  dataset: "Série de données",
  datasetPlural: "Séries de données",
  datasetTypes: {
    cartesian: "Cartésien",
    planPositioning: "Positionnement sur plan",
    file: "Fichier",
    form: "Formulaire",
    gps: "GPS",
    image: "Image",
    images: "Images",
    validation: "Validation",
  },
  days: "{{days}} jours ({{date}})",
  delete: "Supprimer",
  description: "Description",
  discardChanges: "Annuler les modifications",
  documentViewer: {
    zoomIn: "Zoomer",
    zoomOut: "Dézoomer",
    nextPage: "Page suivante",
    previousPage: "Page précédente",
    backToHighlightPage: {
      observation: "Retour à l'observation",
    },
  },
  done: "Terminé",
  download: "Télécharger",
  downloadFile: "Télécharger {{fileName}}",
  downloadPicture: "Télécharger l'image",
  downloadFailed: "Erreur lors du téléchargement",
  duplicate: "Dupliquer",
  duration: {
    years: "une année",
    years_other: "{{count}} années",
    months: "un mois",
    months_other: "{{count}} mois",
    yearsAndMonths: "{{years}} et {{months}}",
  },
  dissociate: "Dissocier",
  batchDissociate: "Dissocier en lot",
  edit: "Modifier",
  email: "Courriel",
  export: "Exporter",
  exportFailed: "Erreur lors de l'exportation",
  files: "Fichiers",
  forms: "Formulaires",
  format: {
    date: "DD-MM-YYYY",
  },
  geojson: {
    label: "Données géospatiales (GeoJSON)",
    clientError: "Le Json n'est pas valide.",
    serverError: 'Le geoJSON n\'est pas valide: "{{error}}"',
  },
  group: "Groupe",
  images: "Images",
  info: "Information",
  jsonRootName: "/",
  jsonSyntaxError: "Erreur de syntaxe JSON",
  language: { label: "Langue" },
  lastUpdate: "Dernière mise à jour",
  lastViewedAt: "Dernière visite",
  leavePage: "Vous avez modifié des données.",
  location: "Localisation",
  locationPlural: "Localisations",
  locationOrSector: "Localisation / Secteur",
  manageUserAccess: "Gérer accès",
  modulePlural: "Modules",
  name: "Nom",
  noData: "Aucune donnée",
  noGroup: "Non groupé",
  notification: "Notification",
  notificationPlural: "Notifications",
  organization: "Organisation",
  filterByOrganization: "Filtrer par organisation",
  organizationPlural: "Organisations",
  otherPlural: "autres",
  observation: "Observation",
  observationPlural: "Observations",
  plugin: "Plugin",
  preview: "Aperçu",
  project: "Projet",
  projectPlural: "Projets",
  reference: "Référence",
  reload: "Recharger",
  remove: "Enlever",
  recommendation: "Recommandation",
  recommendationPlural: "Recommandations",
  restore: "Restaurer",
  riskMatrix: "Matrice de risque",
  save: "Enregistrer",
  scheduledDate: "Date au calendrier",
  search: "Rechercher",
  sortFields: "Trier les champs",
  sortGroups: "Trier les groupes",
  slogan: "Modernisez vos décisions d’affaires",
  map: "Carte",
  mapClusterCount: "Regroupement de {{count}} marqueurs",
  marker: "Marqueur de position",
  list: "Liste",
  listParamsPreview: {
    titleWith: "Filtres et tris actifs",
    titleWithout: "Aucun filtres et tris",
  },
  listResetActions: {
    resetButton: "Réinitialiser les filtres et tris par défaut",
    deleteButton: "Supprimer tous les filtres et tris",
    removeFilter: "Supprimer le filtre",
    removeSort: "Supprimer le tri",
  },
  status: "État",
  subtype: "Sous-type",
  type: "Type",
  unsavedChanges:
    "Vous avez des modifications non enregistrées, êtes-vous sûr de vouloir quitter ?",
  update: "Mettre à jour",
  upload: {
    button: "Téléverser",
    authorizedFileTypes: "Types de fichiers acceptés",
    title: {
      file: "Cliquez ou faites glisser 1 fichier dans cette zone.",
      file_other: "Cliquez ou faites glisser des fichiers dans cette zone.",
      image: "Cliquez ou faites glisser 1 image dans cette zone.",
      image_other: "Cliquez ou faites glisser des images dans cette zone.",
      photo: "Cliquez ou faites glisser 1 photo dans cette zone.",
      photo_other: "Cliquez ou faites glisser des photos dans cette zone.",
    },
    titleMaxCount: {
      file: "Cliquez ou faites glisser des fichiers dans cette zone pour télécharger jusqu'à {{maxCount}} fichiers.",
      image:
        "Cliquez ou faites glisser des images dans cette zone pour télécharger jusqu'à {{maxCount}} images.",
      photo:
        "Cliquez ou faites glisser des photos dans cette zone pour télécharger jusqu'à {{maxCount}} photos.",
    },
    titleReplace: {
      file: "Cliquez ou faites glisser 1 fichier dans cette zone pour remplacer le fichier sélectionné.",
      image:
        "Cliquez ou faites glisser 1 image dans cette zone pour remplacer l'image' sélectionnée.",
      photo:
        "Cliquez ou faites glisser 1 photo dans cette zone pour remplacer la photo sélectionnée.",
    },
    error: {
      fileType: "Le type du fichier téléchargé n'est pas autorisé.",
      nameLength: "Le nom du fichier téléchargé est trop long: {{fileName}}.",
    },
    maxFileSize: "La taille maximale du fichier est de {{maxFileSize}} Mo.",
    maxFileSize_other:
      "La taille maximale des fichiers est de {{maxFileSize}} Mo.",
  },
  uploadFailed: "Le téléversement a échoué",
  uploadFailedVolumeTooLarge:
    "Votre demande de téléversement contient trop de données, veuillez réessayer en réduisant le volume de données.",
  upToDate: "À jour",
  lastModification: "Dernière modification",
  user: "Utilisateur",
  userPlural: "Utilisateurs",
  view: "Inspecter",
  customValue: "Ajouter une entrée",
  deleted: "Supprimé",
  disassociate: "Dissocier",
  active: "Actif",
  statistics: {
    cardClearButton: "réinitialiser",
  },
  defaultCauserName: "Système",
  addFavorite: "Ajouter aux favoris",
  removeFavorite: "Retirer des favoris",
  favoriteError: "Impossible de mettre à jour les favoris",
  loading: "Chargement...",
  listLoadMoreButton: {
    generic: "Voir plus",
    nextPage_male_one: "Voir le prochain {{item}}",
    nextPage_female_one: "Voir la prochaine {{item}}",
    nextPage_male_other: "Voir les {{count}} prochains {{item}}s",
    nextPage_female_other: "Voir les {{count}} prochaines {{item}}s",
    total_male_one: "{{count}} restant",
    total_female_one: "{{count}} restante",
    total_male_other: "{{count}} restants",
    total_female_other: "{{count}} restantes",
    lastPage_male_one: "Voir le dernier {{item}}",
    lastPage_female_one: "Voir la dernière {{item}}",
    lastPage_male_other: "Voir les {{count}} derniers {{item}}s",
    lastPage_female_other: "Voir les {{count}} dernières {{item}}s",
  },
  reset: "Réinitialiser",
  send: "Envoyer",
  previous: "Précédent",
  next: "Suivant",
  zoomIn: "Zoomer",
  zoomOut: "Dézoomer",
  about: {
    title: "À propos de STELAR",
    closeButton: "Fermer",
  },
  sector: "Secteur",
  sectorPlural: "Secteurs",
  subSector: "Sous-secteur",
  subSectorPlural: "Sous-secteurs",
  hierarchy: "Hiérarchie",
  helpCenter: {
    tagline: "Besoin d'aide?",
    button: "Centre d'Aide Stelar",
    shortButton: "Support",
    link: "Centre d'aide STELAR",
    shortLink: "Centre d'aide",
    articleLink: "Consulter le centre d'aide pour plus d'information",
  },
  treeMap: {
    filterByType: {
      location: "Localisation",
      locationSector: "Localisation / Secteurs",
      sector: "Secteurs",
      asset: "Actifs",
    },
    subFilter: {
      conditionRating: "Cote d'état",
      state: "État",
      assetType: "Type d'actif",
      location: {
        position: "Position",
        perimeter: "Périmètre",
        area: "Surface",
      },
    },
  },
  maintenance: {
    title: "Une opération de maintenance est en cours.",
    duration:
      "STELAR ne sera pas accessible au cours cette période: <br /><strong>{{startDate}} au {{endDate}}</strong>.",
    noDuration: "Le retour aux opérations se fera dans les plus brefs délais.",
    description:
      "Cette maintenance est essentielle pour assurer <br />le bon fonctionnement de la plateforme.",
    thanks: "Merci de votre compréhension.",
    support:
      "Pour toute question ou assistance, n'hésitez pas <br />à contacter le support",
  },
  modelLink: {
    activity: "Voir l'activité",
    asset: "Voir l'actif",
    assettype: "Voir le type d'actif",
    technicalform: "Voir le formulaire technique",
    comment: "Voir le commentaire",
    dataset: "Voir le dataset",
    intervention: "Voir l'intervention",
    jobmodule: "Voir le module",
    location: "Voir la localisation",
    observation: "Voir l'observation",
    organization: "Voit l'organisation",
    project: "Voir le projet",
    recommendation: "Voir la recommendation",
    sector: "Voir le secteur",
    severitygrid: "Voir la grille de sévérité",
    template: "Voir le gabarit d'intervention",
    user: "Voir l'utilisateur",
  },
  document: "Document",
  documentPlural: "Documents",
  informationSection: {
    info: "Information",
    warning: "Avertissement",
  },
  details: "Détails",
  state: "État",
  logoAlt: "Logo de {{name}}",
  id: "Id",
  action: {
    assign: "Assigner",
    create: "Ajouter",
    delete: "Supprimer",
    duplicate: "Dupliquer",
    edit: "Modifier",
    export: "Exporter",
    info: "Information",
    view: "Inspecter",
  },
  assignForm: {
    title: "Assigner des utilisateurs",
    users: {
      label: "Utilisateurs",
      placeholder: "Choisir les utilisateurs à assigner",
    },
  },
};
